import apiClient from './api';

export const orderService = {
  create: async (payload) => {
    const res = await apiClient.post('/Orders', payload);
    return res.data;
  },

  getById: async (id) => {
    const res = await apiClient.get(`/Orders/${id}`);
    return res.data;
  },

  getByUser: async (userId) => {
    const res = await apiClient.get(`/Orders/user/${userId}`);
    return res.data;
  },

  getByPackage: async (packageId) => {
    const res = await apiClient.get(`/Orders/package/${packageId}`);
    return res.data;
  }
};
